import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The Best Goulash of your Life",
  "description": "",
  "published": "2017-05-18T00:00:00.000Z",
  "redirect_from": ["/blog/best-goulash/swizec/7602"],
  "categories": "Personal",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <lite-youtube {...{
      "videoid": "Dgz7yOtyokc",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`To make a good goulash, you need patience, love, and onions. Last night, I made the best goulash of my life. Then I ate it and then I was full.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`It worked! Super thick, no flour or corn starch needed. `}<br parentName="p"></br><br parentName="p"></br>{`I am the king and queen of the kitchen! 💪🏼👑 `}<a parentName="p" {...{
          "href": "https://t.co/2cTi1UQesB"
        }}>{`pic.twitter.com/2cTi1UQesB`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/864904723576438784"
      }}>{`May 17, 2017`}</a></blockquote>
    <p>{`If you've cooked such a thing before, these characteristics will mean something to you: it is thick, but requires no flour; it is sweet, but requires no sugar. 🙏🏻`}</p>
    <p>{`If you've never cooked such a thing… trust me that it is difficult. It almost never works out. The patience doesn't combine with the onions well enough, the tomatoes overpower the natural sweetness and make it sour. Things go slightly wrong.`}</p>
    <p>{`Before I tell you how my goulash works, here's a disclaimer: It's not a real goulash. You can think of it as a goulash-inspired sauce.`}</p>
    <p>{`Real goulash has potatoes and works as its own dish. Like a delicious, thick, ridiculously filling soup.`}</p>
    <p>{`Mine is meant to go accompany a carb. You can put it on polenta (a Slovenian favorite), or pasta. Rice would be weird. Potatoes… if you're gonna use potatoes, just make a real goulash, eh?`}</p>
    <h2 {...{
      "id": "heres-what-youll-need"
    }}>{`Here's what you'll need:`}</h2>
    <ul>
      <li parentName="ul">{`onions`}</li>
      <li parentName="ul">{`chopped up cow, "stew chunks" are best`}</li>
      <li parentName="ul">{`carrots`}</li>
      <li parentName="ul">{`diced tomatoes from a can`}</li>
      <li parentName="ul">{`tomato paste`}</li>
      <li parentName="ul">{`paprika powder (mine was "smoked")`}</li>
      <li parentName="ul">{`bay leaves`}</li>
      <li parentName="ul">{`thyme`}</li>
      <li parentName="ul">{`parsley`}</li>
      <li parentName="ul">{`tarragon`}</li>
      <li parentName="ul">{`salt`}</li>
      <li parentName="ul">{`vegetable oil`}</li>
    </ul>
    <p>{`Ingredients are without quantities because you are meant to "eye" those. I used two onions and two carrots and one can of tomatoes for 24oz (about 0.5kg) of cow chunks.`}</p>
    <p>{`Spices are totally eyeballed. Smell them, taste them, see how much stuff you have, and make a call. You can be off by a lot and it's still gonna taste good.`}</p>
    <p>{`The more you cook, the easier this gets. Machine learning. Collect the data ;)`}</p>
    <p>{`You can borrow the following items, if you don't have them. This might involve talking to your friends and neighbors in the real life. Proceed with caution.`}</p>
    <ul>
      <li parentName="ul">{`big pot`}</li>
      <li parentName="ul">{`a lid that matches your pot`}</li>
      <li parentName="ul">{`a stirring device (big wooden spoon recommended)`}</li>
      <li parentName="ul">{`a plate`}</li>
      <li parentName="ul">{`a kitchen knife`}</li>
      <li parentName="ul">{`a wooden kitchen cutting board`}</li>
      <li parentName="ul">{`a chopper (not necessary but makes life easier)`}</li>
      <li parentName="ul">{`a stove`}</li>
      <li parentName="ul">{`some countertop space`}</li>
      <li parentName="ul">{`1 hour of active time`}</li>
      <li parentName="ul">{`1 hour of cooking time with interruptions`}</li>
    </ul>
    <h2 {...{
      "id": "heres-how-you-do-it"
    }}>{`Here's how you do it:`}</h2>
    <p>{`Heat up a big pot. When it's hot, pour in some oil. Add cow chunks. Salt mercilessly. Add tarragon. Turn stove to full blast.`}</p>
    <p>{`Tarragon makes cows more delicious when added early in the cooking process.`}</p>
    <p>{`Stir the cow chunks and salt and tarragon mixture regularly until the cow turns white. A bit of brown is good too. Don't overdo it.`}</p>
    <p>{`While the cow chunks are searing, chop up the onions. The smaller your chop, the better.`}</p>
    <p>{`When cow chunks are ready – no distinct red surfaces – take them out and put them on a plate. Try to leave as much of the juices in the pot as possible.`}</p>
    <p>{`Throw onions into pot. Salt mercilessly. Stir. Cover pot with lid. Turn stove down to half power.`}</p>
    <p>{`While the onions are glazing, you can chop the carrots. The smaller your chop, the better.`}</p>
    <p>{`Regularly check up on the onions. Add small amounts of warm water when the pot goes dry. Stir. Keep covered. The goal is to make the onions turn transparent without browning.`}</p>
    <p>{`This can take anywhere up to 30 or 40 minutes. The more airtight your lid and the more salt you add, the quicker it is. If you add too much salt, your goulash is ruined.`}</p>
    <p>{`When your onions are mostly mushy, add the chopped carrots. Continue the above process until carrots become mushy too.`}</p>
    <p>{`Once the onion-carrot mix is mushy, put the seared cow back in the pot.`}</p>
    <p>{`I can't tell you how you know when the onions and carrots are mushy enough. This part takes practice, patience, and some luck. The longer you wait, the better your goulash. This is what thickens it `}<em parentName="p">{`and`}</em>{` what counteracts the sour of tomato.`}</p>
    <p>{`With the cow-onion-carrot mix in the pot, turn heat back to full blast. Stir until you hear sizzling. This further mushifies the onions and carrots and mixes them with meat juices.`}</p>
    <p>{`It has now been about an hour since you started. Exact timing depends on your quantities and your patience.`}</p>
    <p>{`Add the can of diced tomatoes, the bay leaves, the tomato paste, and the paprika powder. Tomatoes give it taste and moisture, bay leaves add flavor, tomato paste makes it a deeper red, paprika gives it flavor and makes it a deeper red.`}</p>
    <p>{`If you taste your goulash now, it tastes bad. You might think your experiment has failed and you are the worst cook in the world. Have faith, my friend. Goulash takes time.`}</p>
    <p>{`Add enough water. How much is enough depends on how liquidy your can of tomatoes was. If you add too much, don't worry – you can boil it off at the end of cooking. `}<em parentName="p">{`Feel the goulash`}</em>{`.`}</p>
    <p>{`When it boils, turn heat down to a third. Put the lid on the pot, leaving a small crack. Cook for 30 minutes at a gentle boil.`}</p>
    <p>{`After 30 minutes, add parsley and thyme. Stir. Cook for another 20 to 30 minutes.`}</p>
    <p>{`Your goulash is now done. Taste it. It is delicious.`}</p>
    <p>{`Take the pot off the stove. Let it sit overnight. Reheat before eating. Reheating makes goulash better.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      